import useSWR from "swr";
import { fetcher } from "@/lib/api";
import { DataTable, StatusPill, fmtDate } from "@/components/admin/DataTable";

const inr = (n) => `₹${(n || 0).toLocaleString("en-IN")}`;
const person = (c) => <div><div className="font-medium">{c?.name}</div><div className="text-xs text-[#556B57]">{c?.company}</div></div>;
const contact = (c) => <div className="text-xs"><a href={`mailto:${c?.email}`} className="block underline">{c?.email}</a>{c?.phone}</div>;
const when = { label: "Created", key: "created_at", render: (r) => <span className="text-xs whitespace-nowrap">{fmtDate(r.created_at)}</span> };
const status = { label: "Status", key: "status", render: (r) => <StatusPill s={r.status} /> };

export function OrdersTab() {
  const { data } = useSWR("/admin/orders", fetcher);
  const columns = [
    when,
    { label: "Customer", key: "customer", render: (r) => person(r.customer), csv: (r) => `${r.customer?.name} (${r.customer?.company || ""})` },
    { label: "Contact", key: "contact", render: (r) => contact(r.customer), csv: (r) => `${r.customer?.email} / ${r.customer?.phone}` },
    {
      label: "Sample", key: "config",
      render: (r) => <div className="text-xs max-w-[240px]"><div className="font-medium text-sm">{r.config?.product_slug}</div>{[r.config?.packaging, r.config?.size, r.config?.quantity && `Qty ${r.config.quantity}`].filter(Boolean).join(" · ")}</div>,
      csv: (r) => `${r.config?.product_slug} ${r.config?.packaging || ""} ${r.config?.size || ""} x${r.config?.quantity || ""}`,
    },
    { label: "Amount", key: "amount_inr", render: (r) => <span className="font-medium">{inr(r.amount_inr)}</span> },
    { label: "Country", key: "country", render: (r) => r.customer?.country || "-", csv: (r) => r.customer?.country },
    status,
    { label: "Payment ID", key: "razorpay_payment_id", render: (r) => <span className="text-xs">{r.razorpay_payment_id || "-"}</span> },
  ];
  return <DataTable rows={data} columns={columns} testid="admin-orders-table" title="Sample Orders" filename="fresio-sample-orders" />;
}

export function PliTab() {
  const { data } = useSWR("/admin/pli-registrations", fetcher);
  const columns = [
    when,
    { label: "Event", key: "event_name" },
    { label: "Attendee", key: "name", render: (r) => person(r) },
    { label: "Contact", key: "email", render: (r) => contact(r), csv: (r) => `${r.email} / ${r.phone}` },
    { label: "City / Role", key: "city", render: (r) => <span className="text-xs">{[r.city, r.role].filter(Boolean).join(" · ") || "-"}</span>, csv: (r) => `${r.city || ""} ${r.role || ""}` },
    { label: "Seats", key: "attendees" },
    { label: "Amount", key: "amount_inr", render: (r) => inr(r.amount_inr) },
    status,
  ];
  return <DataTable rows={data} columns={columns} testid="admin-pli-table" title="PLI Registrations" filename="fresio-pli-registrations" />;
}

export function MessagesTab() {
  const { data } = useSWR("/admin/messages", fetcher);
  const columns = [
    when,
    { label: "From", key: "name", render: (r) => person(r) },
    { label: "Contact", key: "email", render: (r) => contact(r), csv: (r) => `${r.email} / ${r.phone || ""}` },
    { label: "Message", key: "message", render: (r) => <p className="text-sm max-w-[460px] whitespace-pre-line">{r.message}</p> },
  ];
  return <DataTable rows={data} columns={columns} testid="admin-messages-table" title="Contact Messages" filename="fresio-messages" />;
}
